import { Box, SpacerNew } from '@jfs/ui-new'
import { useCallback, useEffect } from 'react'
import { AepsButton } from '../../../comps/AepsButton'
import { AepsTextInput } from '../../../comps/AepsTextInput'
import { Container } from '../../../comps/Container'
import { useLazyApiData, useStores } from '../../../data/store'
import { Screens } from '../../../nav/Screens'

export const SelectLoginTypeScreen = ({ navigation, route }) => {
  const { mobile, sendOtp } = useStores((store) => ({
    mobile: store.customerDetails.mobile,
    sendOtp: store.moneyTransferSession.sendOtp,
  }))
  const [lazySendOtp, sendOtpHandler] = useLazyApiData(sendOtp)

  useEffect(() => {
    if (sendOtpHandler?.state === 'fulfilled') {
      navigation?.navigate(Screens.DOMESTIC_MONEY_TRANSFER_OTP, { type: 'EXISTING_CUSTOMER_OTP' } as never)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendOtpHandler?.state])

  const onSendOtpPress = useCallback(() => lazySendOtp(mobile), [lazySendOtp, mobile])

  const onBioAuthPress = useCallback(
    () => navigation?.navigate(Screens.SCAN_FINGERPRINT, { type: route.params?.type } as never),
    [navigation, route.params?.type],
  )

  return (
    <Container type="refund" showFooter={true} title="Select Login Option" paddingTop={24}>
      <SpacerNew size={24} />
      <AepsTextInput
        placeholder="Customer Mobile Number"
        value={mobile}
        editable={false}
        tintColor={'#757575' as any}
      />
      <SpacerNew size={48} />
      <Box flexDirection={'row'}>
        <Box f={1}>
          <AepsButton title={'Proceed with OTP'} onPress={onSendOtpPress} />
        </Box>
        <SpacerNew direction="horizontal" size={24} />
        <Box f={1}>
          <AepsButton title={'Proceed with Bio-Auth'} onPress={onBioAuthPress} />
        </Box>
      </Box>
    </Container>
  )
}
